import { en } from './en'
import { zh } from './zh'

const translations: Record<string, Record<string, string>> = { en, zh }

export function t(key: string, lang: string, params?: Record<string, string | number>): string {
  const val = translations[lang]?.[key] || translations.en[key] || key
  if (!params) return val
  return Object.entries(params).reduce(
    (str, [k, v]) => str.replace(`{${k}}`, String(v)),
    val
  )
}

// Get bilingual text from question fields
export function biText(zhText: string, enText: string, lang: string): string {
  if (lang === 'bilingual') {
    if (zhText && enText) return `${zhText}\n${enText}`
    return zhText || enText || ''
  }
  if (lang === 'zh') return zhText || enText || ''
  return enText || zhText || ''
}
